import { z } from 'zod'
import type { PaginatedResponse } from './common'

export const targetUserSchema = z.string().min(1).default('all')

export const createNotificationSchema = z.object({
  title_en: z.string().min(1).max(200),
  title_hi: z.string().min(1).max(200),
  message_en: z.string().min(1).max(2000),
  message_hi: z.string().min(1).max(2000),
  link: z.string().max(500).optional(),
  target_user: targetUserSchema.optional(),
})

export type CreateNotificationInput = z.infer<typeof createNotificationSchema>

export type NotificationResponse = {
  id: string
  legacy_id?: string | null
  title_en: string
  title_hi: string
  message_en: string
  message_hi: string
  link?: string | null
  target_user: string
  is_read: boolean
  created_at: string
  updated_at: string
}

export type PaginatedNotificationResponse =
  PaginatedResponse<NotificationResponse>
